import axios from 'axios'
export default {
  systemConfig:function (valid) {
    return new Promise((resolve, reject) => {
      axios.get('home/system_list',{
        params:{
          id:valid
        }
      }).then(res=>{
        resolve(res)
      }).catch(reason => {
        reject(reason)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/util/system.js